@import "../../../styles/base";
@import "../../../components/design-system/Button/styles/surfaces";

.ButtonSet {
  display: flex;
  align-items: center;
  gap: 1rem;

  &.horizontal {
    flex-flow: row wrap;

    &.start {
      justify-content: start;
    }

    &.end {
      justify-content: end;
    }

    &.stretch {
      justify-content: stretch;

      > * {
        flex: 1 0 1rem;
      }
    }

    &.space-between {
      justify-content: space-between;
      width: 100%;
    }
  }

  &.vertical {
    flex-direction: column;
    align-items: stretch;
  }

  > * {
    margin: 0 !important;
  }

  &:empty {
    display: none;
  }

  .Spacer {
    flex: 1 1 0;
  }
}

.Header {
  padding-bottom: 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .TitleWithActionButtons {
    width: 100%;
    justify-content: space-between;
    display: flex;
    overflow-wrap: anywhere;

    .Title {
      padding-right: 2rem;
      align-content: center;
    }

    .ActionButtons {
      @include button-group;
      display: flex;
      align-items: center;
    }
  }

  .CloseButton {
    display: inline-block;
    padding: 0.29rem;
  }

  .Description {
    margin-top: 0.5rem;
    flex: 1 0 100%;
  }
}

.Footer {
  @include button-group;
  margin-top: 1rem;
  flex: 1;
  position: relative;
  display: flex;
  align-items: end;
  justify-content: flex-end;

  .ButtonSet {
    flex: 0 1 100%;
  }
}

@media screen and (min-width: 484px) {
  .Header {
    align-items: flex-start;

    .TitleWithActionButtons {
      display: flex;

      .ActionButtons {
        display: flex;
        align-items: center;
        min-width: max-content;
      }
    }
  }

  .Footer {
    margin-top: 1.5rem;
  }
}

.ghost {
  @include button-group;
}
